import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {Router} from "@angular/router";
import {NgxPermissionsService} from "ngx-permissions";
// import {AppState} from "../store/reducers";
import {Apollo, gql} from "apollo-angular";
import {NotificationService} from "./notification.service";
import {StorageService} from "./storage.service";
import {map} from "rxjs/operators";
import {baseResponse, baseResponseGraphqlField} from "../store/base.graphql";
import {SettingsService} from "./settings.service";
import {ViewAttachmentComponent} from "../shared/components/pdf-viewer/view-attachment/view-attachment.component";

export const attachmentFields = `
  id
  imageUniqueId
  imagePath
  imageName
  imageType
`;

// export const UPLOAD_MULTIPLE_ATTACHEMENTS = gql`
// mutation MultipleUploadFile($input: DTPFileServerAttachmentsListInputObjects!) {
//   multipleUploadFile(input: $input) {
//     ${baseResponseGraphqlField}
//     data {
//       ${attachmentFields}
//     }
//   }
// }
// `

export const UPLOAD_FILE = gql`
  mutation UploadBase64File($input: Base64FileInputObjects!) {
    uploadBase64File(input: $input) {
      ${baseResponseGraphqlField}
      data {
        ${attachmentFields}
      }
    }
  }
`;

export const UPLOAD_PROFILE_PICTURE = gql`
  mutation UploadProfilePicture($file: FileInputObjects!) {
    uploadProfilePicture(file: $file) {
      response {
        ${baseResponse}
      }
      data {
        ${attachmentFields}
      }
    }
  }
`;

// export const OPEN_FILE = gql`
// query OpenFile($documentPath: String!) {
//   openFile(documentPath: $documentPath) {
//     ${baseResponseGraphqlField}
//     data {
//       ${attachmentFields}
//     }
//   }
// }
// `


@Injectable({
  providedIn: 'root'
})
export class AttachmentService {



  constructor(
    private http: HttpClient,
    private router: Router,
    private permissionsService: NgxPermissionsService,
    // private store: Store<AppState>,
    private apollo: Apollo,
    private notificationService: NotificationService,
    private storage: StorageService,
    private settingsService: SettingsService,
  ) { }

  // async uploadMultipleFiles( input: { serviceName: ProjectServices, documents: { documentName: string, base64String: string | ArrayBuffer }[] }) {
  //   return await this.apollo
  //     .mutate({
  //       mutation: UPLOAD_MULTIPLE_ATTACHEMENTS,
  //       fetchPolicy: 'network-only',
  //       variables: {
  //         input: input
  //       }
  //     })
  //     .pipe(
  //       this.notificationService.catchError(
  //         'Problem occurred while uploading files'
  //       ),
  //       map((data) => {
  //         return Object.values(data)[0].multipleUploadFile;
  //       })
  //     ).toPromise()
  // }
  //
  async uploadSingleFile( input: { fileName: string, base64String: string | ArrayBuffer } ) {
    return await this.apollo
      .mutate({
        mutation: UPLOAD_FILE,
        fetchPolicy: 'network-only',
        variables: {
          input: input
        }
      })
      .pipe(
        this.notificationService.catchError(
          'Problem occurred while uploading file'
        ),
        map((data) => {
          return Object.values(data)[0].uploadBase64File;
        })
      ).toPromise()
  }

  async uploadProfilePhoto( input: { serviceName: string, file: string } ) {
    return await this.apollo
      .mutate({
        mutation: UPLOAD_FILE,
        fetchPolicy: 'network-only',
        variables: {
          input: input
        }
      })
      .pipe(
        this.notificationService.catchError(
          'Problem occurred while uploading profile picture'
        ),
        map((data) => {
          return Object.values(data)[0].uploadProfilePicture;
        })
      ).toPromise()
  }
  // async openFile(documentPath: string) {
  //   return await this.apollo
  //     .mutate({
  //       mutation: OPEN_FILE,
  //       fetchPolicy: 'network-only',
  //       variables: {
  //         documentPath: documentPath
  //       }
  //     })
  //     .pipe(
  //       this.notificationService.catchError(
  //         'Problem occurred while opening file'
  //       ),
  //       map((data) => {
  //         return Object.values(data)[0].openFile;
  //       })
  //     ).toPromise()
  // }

  viewBase64PdfInModal(base64String: string) {
    this.settingsService.openDialogModal({
      data: base64String,
      component: ViewAttachmentComponent
    })
  }
}
